import React from "react";

import Form, { Row, ActionButton, useFieldValue } from "2g-form";
import Buttons, { ButtonsSet } from "2g-buttons";

import useFixniPozadavkyBoxError from "b2b/components/fixni-pozadavky-box/useFixniPozadavkyBoxError";
import FixniPozadavkyBoxErrorContent from "b2b/components/fixni-pozadavky-box/FixniPozadavkyBoxErrorContent";

import useMessages from "./i18n/useMessages";
import RezervaceVytvoreniDatumOd from "./RezervaceVytvoreniDatumOd";
import RezervaceVytvoreniProjekt from "./RezervaceVytvoreniProjekt";
import RezervaceVytvoreniProdukt from "./RezervaceVytvoreniProdukt";
import RezervaceVytvoreniObdobi from "./RezervaceVytvoreniObdobi";
import RezervaceVytvoreniFixniNaroky from "./RezervaceVytvoreniFixniNaroky";
import RezervaceVytvoreniScheduler from "./RezervaceVytvoreniScheduler";
import RezervaceVytvoreniDoplnkoveSluzby from "./RezervaceVytvoreniDoplnkoveSluzby";
import RezervaceVytvoreniPoznamka from "./RezervaceVytvoreniPoznamka";
import useRezervaceVytvoreniForm from "./hooks/useRezervaceVytvoreniForm";
import useRezervaceVytvoreniFormInitializer from "./hooks/useRezervaceVytvoreniFormInitializer";

export const FORM_REZERVACE_VYTVORENI_MODULE_KEY = "rezervaceVytvoreni";

export function RezervaceVytvoreniForm() {
  useRezervaceVytvoreniFormInitializer();
  const { buttonSubmit } = useMessages();
  const fixniPozadavkyBoxError = useFixniPozadavkyBoxError({
    moduleKey: FORM_REZERVACE_VYTVORENI_MODULE_KEY
  });
  const { onSubmit, disabledSubmit } = useRezervaceVytvoreniForm({
    moduleKey: FORM_REZERVACE_VYTVORENI_MODULE_KEY
  });
  const produkt = useFieldValue("produkt", FORM_REZERVACE_VYTVORENI_MODULE_KEY);

  return (
    <Form
      moduleKey={FORM_REZERVACE_VYTVORENI_MODULE_KEY}
      destroyOnUnmount={false}
      onSubmit={onSubmit}
    >
      <FixniPozadavkyBoxErrorContent {...fixniPozadavkyBoxError} />
      {!fixniPozadavkyBoxError.isError || fixniPozadavkyBoxError.faze?.fixni ? (
        <RezervaceVytvoreniProjekt />
      ) : undefined}
      {!fixniPozadavkyBoxError.isError ? (
        <>
          <RezervaceVytvoreniProdukt />
          <RezervaceVytvoreniObdobi />
          <RezervaceVytvoreniFixniNaroky />
          <RezervaceVytvoreniScheduler />
          <Row styled>
            {produkt?.produkt?.bezCasu ? (
              <RezervaceVytvoreniDatumOd />
            ) : undefined}
            {produkt?.doplnkoveSluzby?.length ? (
              <RezervaceVytvoreniDoplnkoveSluzby />
            ) : undefined}
            <RezervaceVytvoreniPoznamka />
          </Row>
          <ButtonsSet>
            <ActionButton
              button={Buttons.Primary}
              submit
              validate
              inverse
              disabled={disabledSubmit}
            >
              {buttonSubmit()}
            </ActionButton>
          </ButtonsSet>
        </>
      ) : undefined}
    </Form>
  );
}

RezervaceVytvoreniForm.propTypes = {};

export default React.memo(RezervaceVytvoreniForm);
